import { Button, TextField, Typography } from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet";
import useGenerateBetaCodeHook from "./BetaCode.hook";
import useStyles from "./BetaCode.styles";

const BetaCode = () => {
    const classes: any = useStyles();
    const {
        handleSubmit,
        handleChange,
        hasError,
        formState
    } = useGenerateBetaCodeHook();

    return (
        <div className={classes.root}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Beta Code | Aviron</title>
                <link rel="canonical" href={window.location.href} />
            </Helmet>
            <div className={classes.content}>
                <div className={classes.contentBody}>
                    <form
                        className={classes.form}
                        onSubmit={handleSubmit}
                    >
                        <div className={classes.logo}>
                            <img src="https://avironactive.com/assets/img/icon/aviron-icon.svg" />
                        </div>
                        <Typography
                            className={classes.title}
                            variant="h2"
                            sx={{
                                marginTop: "16px",
                                marginBottom: "28px"
                            }}
                        >
                             AVIRON BETA PROGRAM
                        </Typography>
                        <div className={classes.introduction}>
                            <ul className={classes.introductionUl}>
                                <li><div className="number">1</div><div className="text">Log out of your current profile on the rower</div></li>
                                <li><div className="number">2</div><div className="text">Log in with the following credentials
                                    <br />Username: support
                                    <br />Password: support</div></li>
                                <li><div className="number">3</div><div className="text">A code should appear on your screen, please re-type that code below in the code generator and click on generate</div></li>
                                <li><div className="number">4</div><div className="text">A code should appear here and please paste this code on your rower</div></li>
                                <li><div className="number">5</div><div className="text">Click on “settings” which is located on the bottom left corner of the screen</div></li>
                                <li><div className="number">6</div><div className="text">Select “Change Environment” until the mode shows “BETA”</div></li>
                                <li><div className="number">7</div><div className="text">Click on “Restart” to complete the process</div></li>
                                <li><div className="number">8</div><div className="text">Please allow a few minutes for the system to download the new update.</div></li>
                                <li><div className="number">9</div><div className="text">When you want to revert back to live mode, please click on “settings” and click on “Production Mode” and click on restart</div></li>
                                <div></div>
                            </ul>
                        </div>
                        <h2 className={classes.title}>
                            PLEASE INTER YOUR CODE BELOW
                        </h2>
                        <TextField
                            className={classes.textField}
                            error={hasError("code")}
                            fullWidth
                            helperText={
                                hasError("code")
                                    ? formState.errors.code[0]
                                    : null
                            }
                            // label="APK CODE"
                            placeholder="APK CODE"
                            name="code"
                            onChange={handleChange}
                            onBlur={handleChange}
                            type="text"
                            value={formState.values.code || ""}
                            variant="outlined"
                            data-cy="login-code-field"
                            sx={{
                                marginTop: "16px"
                            }}
                        />

                        <Button
                            className={classes.signInButton}
                            color="primary"
                            disabled={!formState.isValid}
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                            data-cy="login-submit-button"
                            sx={{
                                marginTop: "24px"
                            }}
                        >
                            GENERATE
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default BetaCode;